export const ContentDate = (props) => {
  return <div className="reviseddate"></div>;
};
